import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28177786")

_pushScopeId("data-v-28177786")
const _hoisted_1 = { class: "confirmation" }
const _hoisted_2 = { class: "content_ls_margin" }
const _hoisted_3 = { class: "ls-slate-dark" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageHeader), 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode("div", { innerHTML: _ctx.pageBody }, null, 8, ["innerHTML"])
    ])
  ]))
})